<template>
  <div class="select-nft" @click="onClose">
    <div class="container">
      <div
        class="card animate__animated animate__fadeIn"
        @click="preventBubble"
      >
        <div class="card-header">
          <div class="row">
            <div class="col-auto"><h3 class="text-start">Select NFT</h3></div>
            <div class="col text-end">
              <button
                v-if="showDangerous"
                @click="toggleDangerous"
                class="btn btn-solid-primary fadeIn fw-bold me-2"
              >
                <i class="fa fa-arrow-left"></i>
              </button>
              <button
                @click="refreshUserAssets"
                class="btn btn-solid-primary fadeIn"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
            <div class="col-12 col-md order-2 order-md-1 mt-2 mt-md-0">
              <input
                id="search"
                class="form-control form-control-lg"
                placeholder="Search NFT's"
                v-model="search"
                autocomplete="off"
              />
            </div>
            <div @click="onClose" class="col-auto order-1 order-md-2">
              <i class="fa fa-close fa-2x mt-1"></i>
            </div>
          </div>
        </div>
        <div
          class="card-body"
          :class="{
            'd-flex justify-content-center align-items-center':
              nfts.length === 0,
          }"
        >
          <MultiWallet
            v-if="!$store.state.wallet.connected"
            class="glow-sub"
          ></MultiWallet>
          <div
            class="d-flex justify-content-center align-items-center"
            v-else-if="nfts.length === 0"
          >
            <h3 class="my-5 h-100 text-center">Loading NFT's</h3>
          </div>
          <div v-else class="row scroll-container">
            <div
              class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3"
              :key="nft.id.toString()"
              v-for="nft in showDangerous ? dangerNfts : filteredSearch"
            >
              <NFTTile @selected="onSelected" :nft="nft"></NFTTile>
            </div>

            <div class="col-6 col-md-4 col-lg-2 mb-3" v-if="!showDangerous">
              <DefaultNFTTile
                @selected="toggleDangerous"
                :count="dangerNfts.length"
                icon="fa-flag"
              ></DefaultNFTTile>
            </div>

            <button
              v-if="search.length > limit"
              class="btn btn-outline-secondary mx-5"
            >
              Load More
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NFTTile from "@/components/nft/NFTTile";
import MultiWallet from "@/components/wallet/MultiWallet";
import DefaultNFTTile from "@/components/nft/DefaultNFTTile";
import { UserAssets } from "@/api/nft_fraction/user_assets";

export default {
  name: "SelectNFT",
  components: { DefaultNFTTile, MultiWallet, NFTTile },
  props: {
    filter: {
      type: String,
    },
    custom_owner: {
      type: String,
    },
  },
  data() {
    return {
      showDangerous: false,
      ua: null,
      search: "",
      limit: 50,
      custom_owner_nfts: [],
    };
  },
  watch: {
    search: function () {
      if (this.search.length === 44) {
        console.log("NFT DETECTED ADDR", this.search.length);
      }
    },
  },
  computed: {
    nfts: function () {
      if (this.custom_owner) return this.custom_owner_nfts;

      return this.$store.state.cache.userNFTs;
    },
    dangerNfts: function () {
      return this.nfts.filter((n) => {
        if (!n.isDangerous) return false;

        if (this.filter !== n.collection) return false;

        return this.search.length > 1
          ? n.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
              n.mint.indexOf(this.search) > -1
          : true;
      });
    },
    filteredSearch: function () {
      let nfts = this.nfts.filter((n) => !n.isDangerous);

      if (this.filter)
        nfts = nfts.filter((n) => {
          return this.filter === n.collection.toString();
        });

      if (this.search.length > 1) {
        nfts = this.nfts.filter((n) => {
          return (
            n.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            n.mint.indexOf(this.search) > -1
          );
        });
      }

      return nfts;
    },
  },
  methods: {
    preventBubble: function (e) {
      e.stopPropagation();
    },

    toggleDangerous: function () {
      this.showDangerous = !this.showDangerous;
    },

    refreshUserAssets: function () {
      this.getUserAssets();
    },

    onClose: function () {
      this.$emit("close");
    },
    onSelected: function (key) {
      console.log(`onSelected`, key);
      this.$emit("selected", key);
    },
    onKeypress: function (e) {
      if (e.key === "Escape") this.$emit("close");
    },
    getUserAssets: function () {
      console.log(
        "Getting user assets",
        this.custom_owner || this.$store.state.wallet.address
      );
      this.ua.reloadAccountInfo(
        this.custom_owner || this.$store.state.wallet.address,
        () => {
          if (this.custom_owner) {
            this.custom_owner_nfts = this.ua.ownedNFT;
            return;
          }

          this.$store.commit("cache/set_user_nfts", this.ua.ownedNFT);
        }
      );
    },
  },
  beforeMount() {
    const uri =
      this.$store.state.settings.customRpcUrl || this.$store.state.rpc.rpcUrl;
    this.ua = new UserAssets(uri, {
      commitment: "confirmed",
    });

    this.getUserAssets();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", (e) => this.onKeypress(e));
  },
  mounted() {
    window.addEventListener("keydown", (e) => this.onKeypress(e));

    document.getElementById("search").focus();
  },
};
</script>

<style scoped>
.select-nft {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  cursor: default;

  z-index: 10;
  background: transparent;

  animation-name: darken;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

.card {
  margin: auto;
  margin-top: 5vh;
  min-height: 80vh;
}

.scroll-container {
  max-height: 85vh;
  overflow-y: auto;
}
</style>
